import * as React from 'react';
import type { InfoBarShowDetailsAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfobarShowHideDetailsPart, InfobarShowHideDetailsPartProps } from 'owa-info-bar-view';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import getInfoBarLinkColorStyle from 'owa-info-bar/lib/utils/getInfoBarLinkColorStyle';
import {
    MailTipsActionType,
    MailTipsType,
    MailTipsCategory,
    roundOffCount,
    MailtipsActionDatapointName,
} from '../datapoints';
import { logUsage } from 'owa-analytics';

import styles from './MultiRecipientMailtip.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface MultiRecipientMailtipProps {
    colorScheme?: ColorScheme;
    messageInfoElement: JSX.Element;
    removeAllActionElement?: JSX.Element;
    showHideDetails?: InfoBarShowDetailsAction;
    detailsRenderer: () => JSX.Element;
    mailTipsCategory?: MailTipsCategory;
    recipientCount?: number;
}

export interface MultiRecipientMailtipState {
    isDetailShown: boolean;
}

export default function MultiRecipientMailtip(props: MultiRecipientMailtipProps) {
    const [isDetailShown, setIsDetailShown] = React.useState<boolean>(false);
    const toggleIsDetailShown = () => {
        const { mailTipsCategory, recipientCount } = props;
        setIsDetailShown(!isDetailShown);
        // Log datapoint
        const actionType = !isDetailShown
            ? MailTipsActionType.HideDetails
            : MailTipsActionType.ShowDetails;
        logUsage(MailtipsActionDatapointName, [
            actionType,
            mailTipsCategory,
            MailTipsType.MultipleRecipients,
            roundOffCount(recipientCount),
        ]);
    };
    const getShowHideDetailsActionText = (): JSX.Element => {
        if (!props.showHideDetails) {
            return null;
        }
        const infobarShowHideDetailsPartProps: InfobarShowHideDetailsPartProps = {
            ...props.showHideDetails,
            isShowingDetails: isDetailShown,
            clickHandler: toggleIsDetailShown,
            className: classNames(styles.link, getInfoBarLinkColorStyle(props.colorScheme)),
        };
        return <InfobarShowHideDetailsPart {...infobarShowHideDetailsPartProps} />;
    };
    const shouldAddSpaceAfterMessageInfoElement =
        props.removeAllActionElement || props.showHideDetails;
    return (
        <>
            <span
                className={classNames({
                    blankSpaceAfter: shouldAddSpaceAfterMessageInfoElement,
                })}>
                {props.messageInfoElement}
            </span>
            {getShowHideDetailsActionText()}
            {props.removeAllActionElement && props.showHideDetails ? <span> | </span> : null}
            {props.removeAllActionElement}
            {isDetailShown && props.detailsRenderer()}
        </>
    );
}
